import { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import useDocumentTitle from "../../hooks/useDocumentTitle";

export default function Index() {
  useDocumentTitle('Dashboard');
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d");

    // 🔥 Destroy previous chart if exists
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    chartInstanceRef.current = new Chart(ctx, {
      type: "line",
      data: {
        labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        datasets: [
          {
            label: "Flight Bookings",
            data: [12, 19, 7, 11, 15, 9, 14],
            borderColor: "#3b82f6",
            tension: 0.3,
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          y: {
            beginAtZero: true,
            ticks: { stepSize: 5 },
          },
        },
        plugins: {
          legend: { display: true },
        },
      },
    });

    // ✅ Destroy chart on unmount
    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, []);


  return (
    <div className="bg-gray-100 text-gray-800 relative min-h-screen">

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 space-y-6">
        {/* Widgets */}
        <section className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Widget title="Flight Bookings" value="1,234" />
          <Widget title="Hotel Bookings" value="567" />
          <Widget title="Holiday Packages" value="89" />
        </section>

        {/* Chart */}
        <section className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-semibold mb-4">Weekly Flight Bookings</h3>
          <canvas ref={chartRef} className="w-full h-64" />
        </section>

        {/* Credit Summary */}
        <section className="bg-white rounded-lg shadow p-6 max-w-md">
          <h3 className="text-lg font-semibold mb-4">Agent Credit Summary</h3>
          <div className="text-2xl font-bold text-yellow-600 mb-2">₹12,345</div>
          <div className="text-sm text-gray-600">Remaining credit balance</div>
        </section>
      </main>

      {/* Footer 
      <footer className="bg-white border-t mt-12 py-4 text-center text-gray-600 text-sm">
        &copy; 2025 TravelPro B2B. All rights reserved.
      </footer>
      */}
    </div>
  );
}

function Widget({ title, value }) {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      <p className="text-3xl font-bold text-blue-600">{value}</p>
    </div>
  );
}
